import * as React from 'react';
import { Checkbox as CheckboxPrimitive } from '@/features/ui/primitives/checkbox';
import { cn } from '@/lib/utils';

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive
    ref={ref}
    className={cn(
      'data-[state=checked]:bg-blue-600 data-[state=checked]:text-white', // Match checked state color
      className
    )}
    {...props}
  />
));
Checkbox.displayName = 'Checkbox';

export { Checkbox };
